export default "__VITE_ASSET__79e938d8__"